exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".answer-item img{max-width:100%;height:auto}.small-size{font-size:70%;font-weight:400}", ""]);

// exports
